// Espejo en el cliente de la lista blanca del backend (EspaciosController.php:
// espacioRutaPermitida). Solo decide en qué peticiones se manda X-Espacio; la
// autorización real siempre la hace el servidor.

export function rutaSinQuery(url = '') {
  return String(url).split('?')[0].replace(/^\/+|\/+$/g, '');
}

export function rutaEnEspacio(rol, metodo, url) {
  const m = String(metodo || 'get').toUpperCase();
  const ruta = rutaSinQuery(url);
  if (ruta.includes('..')) return false;

  if (rol === 'contador') {
    if (m !== 'GET') return false;
    return [
      'transacciones', 'transacciones/filtros', 'finanzas/transacciones',
      'cfdi/historial', 'cfdi/fiscal',
      'exportar/transacciones', 'exportar/presupuestos', 'exportar/deudas',
    ].includes(ruta);
  }

  if (rol === 'hogar') {
    if (ruta === 'compartidos/conmigo' || /^compartidos\/participantes\/\d+\/(aceptar|rechazar)$/.test(ruta)) return false;
    if (ruta === 'presupuestos' || ruta === 'compartidos'
      || /^presupuestos\/[a-z0-9_-]+$/.test(ruta)
      || /^compartidos\/[a-z0-9_/-]+$/.test(ruta)) {
      return ['GET', 'POST', 'PUT', 'DELETE'].includes(m);
    }
    return m === 'GET' && ruta === 'categorias';
  }
  return false;
}
